// Permanent identifiers for the shipped boards; never derive these from display names.
export const ORIGINAL_IDS = Object.freeze([
    'easy-street', 'long-island', 'ghost-town', 'tunnel-vision',
    'point-of-no-return', 'bug-city', 'gang-land'
]);
export const originalId = index => ORIGINAL_IDS[index];
export const originalIndex = id => ORIGINAL_IDS.indexOf(id);
export const isOriginal = id => originalIndex(id) >= 0;
